import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import LoadingSpinner from './LoadingSpinner';

const ProtectedRoute = ({ children, roles = [] }) => {
  const { isAuthenticated, loading, user } = useAuth();
  const location = useLocation();

  // Show loading spinner while checking auth
  if (loading) {
    return <LoadingSpinner />;
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated || !user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Check role-based access
  if (roles.length > 0 && !roles.includes(user.role)) {
    // Redirect to appropriate dashboard based on user role
    const redirectPath = user.role === 'superadmin' ? '/superadmin'
                       : (user.role === 'admin' || user.role === 'sub_agent' || user.role === 'vendor_agent') ? '/admin' 
                       : user.role === 'agent2' ? '/leads'
                       : user.role === 'restricted_admin' ? '/restricted-dashboard'
                       : user.role === 'affiliate_admin' ? '/affiliate'
                       : user.role === 'data_vendor' ? '/vendor-dashboard'
                       : '/dashboard';
    return <Navigate to={redirectPath} replace />;
  }

  return children;
};

export default ProtectedRoute;
